/**
 * PUNISH'D THEME - ANIMATIONS
 * GSAP-powered animations and interactions
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {

    // Check if GSAP is loaded
    if (typeof gsap === 'undefined') {
      console.warn('GSAP not loaded. Animations disabled.');
      return;
    }

    // ===================================
    // PUN PARADE ANIMATION
    // ===================================
    initParadeAnimation();

    // ===================================
    // BUTTON HOVER ANIMATIONS
    // ===================================
    initButtonAnimations();

    // ===================================
    // COLLECTION CARD ANIMATIONS
    // ===================================
    initCollectionCardAnimations();

    // ===================================
    // LOGO ANGRY D SHAKE
    // ===================================
    initLogoAnimation();

    // ===================================
    // PRODUCT CARD HOVER
    // ===================================
    initProductCardAnimations();

    // ===================================
    // SCROLL ANIMATIONS
    // ===================================
    initScrollAnimations();

    // ===================================
    // FEATURED SHIRTS HOVER
    // ===================================
    initFeaturedShirtsAnimation();

  });

  /**
   * Initialize Parade Animation
   */
  function initParadeAnimation() {
    const paradeTrack = document.querySelector('[data-parade-track]');

    if (!paradeTrack) return;

    const paradeItems = Array.from(paradeTrack.children);

    if (paradeItems.length === 0) return;

    // Duplicate items for seamless loop
    paradeItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      paradeTrack.appendChild(clone);
    });

    // Calculate track width (half since we duplicated)
    const trackWidth = paradeTrack.scrollWidth / 2;

    // Get animation speed from data attribute or settings
    const speed = paradeTrack.dataset.speed || 40;

    // Animate the track
    gsap.to(paradeTrack, {
      x: -trackWidth,
      duration: parseFloat(speed),
      ease: 'none',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize(x => parseFloat(x) % trackWidth)
      }
    });

    // Pause on hover
    const paradeContainer = paradeTrack.parentElement;

    paradeContainer.addEventListener('mouseenter', () => {
      gsap.to(paradeTrack, { timeScale: 0.2, duration: 0.5 });
    });

    paradeContainer.addEventListener('mouseleave', () => {
      gsap.to(paradeTrack, { timeScale: 1, duration: 0.5 });
    });
  }

  /**
   * Initialize Button Animations
   */
  function initButtonAnimations() {
    const buttons = document.querySelectorAll('.btn');

    buttons.forEach(btn => {
      btn.addEventListener('mouseenter', function() {
        gsap.to(this, {
          scale: 1.05,
          duration: 0.2,
          y: -2,
          x: -2,
          ease: 'power2.out'
        });
      });

      btn.addEventListener('mouseleave', function() {
        gsap.to(this, {
          scale: 1,
          duration: 0.2,
          y: 0,
          x: 0,
          ease: 'power2.out'
        });
      });
    });
  }

  /**
   * Initialize Collection Card Animations
   */
  function initCollectionCardAnimations() {
    const cards = document.querySelectorAll('.collection-card');

    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        gsap.to(this, {
          y: -8,
          x: -8,
          duration: 0.3,
          ease: 'power2.out'
        });
      });

      card.addEventListener('mouseleave', function() {
        gsap.to(this, {
          y: 0,
          x: 0,
          duration: 0.3,
          ease: 'power2.out'
        });
      });
    });
  }

  /**
   * Initialize Logo Animation
   */
  function initLogoAnimation() {
    const logo = document.querySelector('.logo');
    const angryD = document.querySelector('.angry-d');

    if (!logo || !angryD) return;

    logo.addEventListener('mouseenter', function() {
      gsap.to(angryD, {
        x: 3,
        repeat: 4,
        yoyo: true,
        duration: 0.05,
        ease: 'power1.inOut',
        onComplete: function() {
          gsap.to(angryD, { x: 0, duration: 0.1 });
        }
      });
    });
  }

  /**
   * Initialize Product Card Animations
   */
  function initProductCardAnimations() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(card => {
      // Subtle lift on hover
      card.addEventListener('mouseenter', function() {
        gsap.to(this, {
          y: -4,
          duration: 0.3,
          ease: 'power2.out'
        });
      });

      card.addEventListener('mouseleave', function() {
        gsap.to(this, {
          y: 0,
          duration: 0.3,
          ease: 'power2.out'
        });
      });
    });
  }

  /**
   * Initialize Scroll Animations
   */
  function initScrollAnimations() {
    // Fade in elements as they enter viewport
    const animatedElements = document.querySelectorAll('.product-card, .collection-card');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.fromTo(entry.target,
              {
                opacity: 0,
                y: 30
              },
              {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out'
              }
            );
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      animatedElements.forEach(el => {
        el.style.opacity = '0';
        observer.observe(el);
      });
    }
  }

  /**
   * Initialize Featured Shirts Hover Animations
   */
  function initFeaturedShirtsAnimation() {
    const leftShirt = document.querySelector('[data-hero-shirt-left]');
    const rightShirt = document.querySelector('[data-hero-shirt-right]');

    // Left shirt - tilts more on hover with a wiggle
    if (leftShirt) {
      const leftFrame = leftShirt.querySelector('.featured-shirt-frame');
      const leftBadge = leftShirt.querySelector('.featured-shirt-badge');

      leftShirt.addEventListener('mouseenter', function() {
        gsap.to(leftFrame, {
          rotation: -8,
          scale: 1.05,
          duration: 0.3,
          ease: 'back.out(1.7)'
        });

        if (leftBadge) {
          gsap.to(leftBadge, {
            rotation: 20,
            scale: 1.15,
            duration: 0.3,
            ease: 'elastic.out(1, 0.3)'
          });
        }
      });

      leftShirt.addEventListener('mouseleave', function() {
        gsap.to(leftFrame, {
          rotation: 0,
          scale: 1,
          duration: 0.3,
          ease: 'power2.out'
        });

        if (leftBadge) {
          gsap.to(leftBadge, {
            rotation: 15,
            scale: 1,
            duration: 0.3
          });
        }
      });
    }

    // Right shirt - tilts more on hover with a wiggle
    if (rightShirt) {
      const rightFrame = rightShirt.querySelector('.featured-shirt-frame');
      const rightBadge = rightShirt.querySelector('.featured-shirt-badge');

      rightShirt.addEventListener('mouseenter', function() {
        gsap.to(rightFrame, {
          rotation: 8,
          scale: 1.05,
          duration: 0.3,
          ease: 'back.out(1.7)'
        });

        if (rightBadge) {
          gsap.to(rightBadge, {
            rotation: 10,
            scale: 1.15,
            duration: 0.3,
            ease: 'elastic.out(1, 0.3)'
          });
        }
      });

      rightShirt.addEventListener('mouseleave', function() {
        gsap.to(rightFrame, {
          rotation: 0,
          scale: 1,
          duration: 0.3,
          ease: 'power2.out'
        });

        if (rightBadge) {
          gsap.to(rightBadge, {
            rotation: 15,
            scale: 1,
            duration: 0.3
          });
        }
      });
    }
  }

  /**
   * Rotating Featured Pun Animation
   */
  function initRotatingPun() {
    const punImage = document.querySelector('.featured-pun-image');

    if (!punImage) return;

    gsap.to(punImage, {
      rotation: 360,
      duration: 20,
      ease: 'none',
      repeat: -1
    });
  }

  // Initialize rotating pun if exists
  initRotatingPun();

})();
